import type { SceneAudioStimulus } from "../config/scene-stimulus-schema";

export class SceneFootstepAudio {
  private readonly player = new Audio();
  private currentUrl: string | null = null;
  private moving = false;
  private unlocked = false;

  constructor() {
    this.player.loop = true;
    this.player.preload = "auto";
    this.player.volume = 0.82;
  }

  unlock(): void {
    this.unlocked = true;
    this.player.muted = true;
    void this.player.play().then(() => {
      this.player.pause();
      this.player.muted = false;
    }).catch(() => {
      this.player.muted = false;
    });
  }

  setStimulus(stimulus: SceneAudioStimulus): void {
    const url = new URL(stimulus.url, document.baseURI).href;
    if (url === this.currentUrl) return;
    this.stop();
    this.currentUrl = url;
    this.player.src = url;
    this.player.load();
  }

  setMoving(moving: boolean): void {
    this.moving = moving;
    if (moving) void this.play();
    else this.player.pause();
  }

  preview(): void {
    void this.play();
    window.setTimeout(() => {
      if (!this.moving) this.player.pause();
    }, 1800);
  }

  stop(): void {
    this.player.pause();
    this.player.currentTime = 0;
    this.moving = false;
  }

  private async play(): Promise<void> {
    if (!this.unlocked || !this.currentUrl) return;
    try {
      await this.player.play();
    } catch (error) {
      console.warn("Footstep audio playback was blocked or failed.", error);
    }
  }
}
